module.exports = __webpack_public_path__ + "static/img/yu.4748278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/yu.png
// module id = OrH0
// module chunks = 0